import {
	ProcessStatus,
	type ProcessStep,
	calculateProgress,
} from "@zetalabs/core";
import { HStack } from "../layout/stack";
import { cn } from "../lib/utils";
import { ProgressIndicatorBullet } from "../loaders/progress-indicator-bullet";

export interface SubTaskProps {
	data: ProcessStep;
	isActive?: boolean;
	isCanceled?: boolean;
}

export function SubProcessRenderer({
	data,
	isActive = false,
	isCanceled = false,
}: SubTaskProps): React.ReactElement {
	const { duration, createdAt, status } = data;

	const progress = calculateProgress(
		duration,
		createdAt ? new Date(createdAt) : null,
	);

	const isReady = status >= ProcessStatus.RUNNING;

	return (
		<HStack className="items-center lg:ml-2 px-4 gap-4">
			<div className="flex items-center h-12">
				<ProgressIndicatorBullet
					done={isReady}
					duration={duration}
					isActive={isActive}
					isCanceled={isCanceled}
					progress={progress}
				/>
			</div>
			<span
				className={cn(
					isReady || "text-message-text-agent-secondary",
					"truncate lg:line-clamp-2 text-wrap",
				)}
				title={data.description}
			>
				{data.description}
			</span>
		</HStack>
	);
}
